__turbopack_context__.v({
  "chevron": "ChangeOriginButton-module__cMLvBW__chevron",
  "chevronOpen": "ChangeOriginButton-module__cMLvBW__chevronOpen",
  "originButton": "ChangeOriginButton-module__cMLvBW__originButton",
});
